import React, { useEffect, useState } from 'react';


import data from '../data/thirukkural.json'
import detailThirukkural from '../data/detail.json'
import { chapters } from '../data/chapters';
import { Design } from './Design';
// import {chapters} from './data/chapters.js'

export const Thirukkural = () => {
    const [kuralNumber, setKuralNumber] = useState(1);
    const [sections, setSections] = useState([]);

    const selectedKural = data.kural.find(kural => kural.Number === parseInt(kuralNumber));

    const calculateAthikaram = (number) => {
        return Math.ceil(number / 10);
    };

    const athikaram = selectedKural ? calculateAthikaram(selectedKural.Number) : null;

    const [athikaramName, setAthikaramName] = useState('');
    const [athikaramNumber, setAthikaramNumber] = useState();

    const findSections = (chapterName, data) => {
        const foundSections = [];
        data.forEach(entry => {
            if (entry.section) {
                const sectionsData = entry.section.detail;
                sectionsData.forEach(section => {
                    const chaptersData = section.chapterGroup.detail;
                    chaptersData.forEach(chapter => {
                        if (chapter.chapters.detail) {
                            chapter.chapters.detail.forEach(subchapter => {

                                if (subchapter.name === chapterName) {
                                    foundSections.push({
                                        section: section.name,
                                        chapter: chapter.name
                                    });
                                }
                            });
                        }
                    });
                });
            }
        });
        return foundSections;
    };

    useEffect(() => {
        const calculateAthikaram = (number) => {
            return Math.ceil(number / 10);
        };
        const athikaramNumber = selectedKural ? calculateAthikaram(selectedKural.Number) : null;
        const foundAthikaram = chapters.find(chapter => chapter.number === athikaramNumber);
        const name = foundAthikaram ? foundAthikaram.name : '';
        setAthikaramName(name);
        setAthikaramNumber(athikaramNumber);
        const foundSections = findSections(name, detailThirukkural);
        console.log(foundSections);
        setSections(foundSections);
    }, [kuralNumber]);

    const numbers = Array.from({ length: 1330 }, (_, index) => index + 1);
    const chunkArray = (arr, size) =>
        Array.from({ length: Math.ceil(arr.length / size) }, (_, index) =>
            arr.slice(index * size, index * size + size)
        );

    // Chunk the numbers array into groups of 5
    const chunkedNumbers = chunkArray(numbers, 10);

    return (
        <div className="App">
            <div className="container pt-3">
                <input className='form-control mb-3 w-25' type="number" max={1330} min={1} value={kuralNumber} onChange={(e) => setKuralNumber(e.target.value)} />


                {selectedKural && (
                    <div key={selectedKural.Number}>

                        <h2>திருக்குறள் - அதிகாரம் - {athikaramNumber} ({athikaramName}) - குறள் - {selectedKural.Number} || Thirukkural </h2>
                        <br />
                        <span>Thirukkural,அதிகாரம்  -  {athikaramNumber},{athikaramName},திருக்குறள்,</span>

                        <Design athikaaram={`${athikaramNumber} (${athikaramName})`} kural_no={selectedKural.Number} paal={sections[0]?.section} iyal={sections[0]?.chapter} line1={selectedKural.Line1} line2={selectedKural.Line2} explain={selectedKural.mv} />

                        < h3 className="sub-heading">குறள்:</h3>

                        <div className="kural">
                            <p>{selectedKural.Line1}</p>
                            <p>{selectedKural.Line2}</p>
                        </div>

                        <br />

                        <h3 className="sub-heading">விளக்கம்:</h3>
                        <p className="para">{selectedKural.mv}</p>
                        <p className="float-end person"><i>- டாக்டர் மு.வரதராசனார்</i></p>

                        <br />
                        <br />

                        <p className="para">{selectedKural.sp}</p>
                        <p className="float-end person"><i>- சாலமன் பாப்பையா</i></p>

                        <br />
                        <br />

                        <p className="para">{selectedKural.mk}</p>
                        <p className="float-end person"><i>- மு. கருணாநிதி</i></p>

                        <br />
                        <br />

                        <h3 className="sub-heading">Translation:</h3>
                        <p className="para">{selectedKural.Translation}</p>

                        <br />

                        <h3 className="sub-heading">Explanation:</h3>
                        <p className="para">{selectedKural.explanation}</p>

                        <br />

                        <h3 className="sub-heading">Transliteration:</h3>
                        <h3 className="sub-heading"><span>Line1 : </span><span className="kural">{selectedKural.transliteration1}</span></h3>
                        <h3 className="sub-heading"><span>Line2 : </span><span className="kural">{selectedKural.transliteration2}</span></h3>

                        <br />
                    </div>
                )}


            </div>
            {/*
        <hr />
  
         <div className="container">
          {chunkedNumbers.map((chunk, chapterIndex) => (
            <div key={chapterIndex} className="chapter">
              <h5>
                <a href={`https://thiruvalluvar-thirukkural.blogspot.com/search/label/${chapters[chapterIndex]?.name}`} rel='nofollow' className='text-decoration-none kural'>
                {chapterIndex + 1}. {chapters[chapterIndex]?.name}
                </a>
              </h5>
              <br />
              <div className="d-flex flex-wrap">
                {chunk.map((number) => {
                  const link = `https://thiruvalluvar-thirukkural.blogspot.com/2024/${number >= 626 ? '03' : '04'}/${chapterIndex + 1}-${number}-thirukkural.html`;
                  return (
                    <p className="kural" key={number} style={{ width: '120px' }}>
                      <a href={link} rel='nofollow' className='text-decoration-none'>குறள் - {number}</a>
                    </p>
                  );
                })}
              </div>
              <br />
            </div>
          ))}
        </div> */}
        </div >
    );
}
